module.exports = __webpack_public_path__ + "static/media/dark-theme-mode-icon.7f90c525.svg";